export const saveModal = 'Document has been saved as draft.';
export const publishModal = 'Document has been saved and published.';
export const errorModal = 'Something went wrong. The document was not saved. Please try again.';
